import FormController from 'controllers/form-controller';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class RegistrationsDetailsFormController extends FormController {
  connect() {
    super.connect();
  }

  validateFields(event) {
    event.preventDefault();
    super.showSpinner();

    super.validateFields();

    this.validateFullName();
    this.validateUsername();

    if (this.formValid) {
      triggerCustomEvent(events.sessions.new_account_created, {
        accountType: 'free',
      });

      this.continueRegistration();
    } else {
      super.hideSpinner();
    }
  }

  continueRegistration() {
    // start: split test download_limit_modal
    if (this.downloadLimitModal || this.guestDownloadLimitModal) {
      this.element.action = `${this.element.action}?download_limit=true&signup_from_resource_show=true`;
    }
    // end: split test download_limit_modal

    this.checkNewsletterOption();
    this.submit();
  }

  checkNewsletterOption() {
    const newsletterOption = document.getElementById('newsletter');

    if (newsletterOption && newsletterOption.checked) {
      sessionStorage.setItem('newsletter_preference', 'newsletter_signup');
    } else {
      sessionStorage.setItem('newsletter_preference', 'no_newsletter_signup');
    }
  }

  get downloadLimitModal() {
    const modalWrapElem = this.element.closest('.ez-session-modal__wrap');
    return modalWrapElem.classList.contains('from-dl-limit-modal');
  }

  // start: split test download_limit_modal
  get guestDownloadLimitModal() {
    const modalWrapElem = this.element.closest('.ez-session-modal__wrap');
    return modalWrapElem.classList.contains('download-limit-form');
  }
  // end: split test download_limit_modal

  controlThreeLimitSignup() {
    triggerCustomEvent(events.three_download_limit.control_step_two_click);
  }

  threeLimitSignup() {
    triggerCustomEvent(events.three_download_limit.step_two_click);
  }
}
